import { Link } from 'react-router-dom';
import ContentCard from '@/components/feature/ContentCard';
import SectionHeading from '@/components/feature/SectionHeading';
import { contentItems } from '@/mocks/content';
import { useSeo } from '@/hooks/useSeo';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryShortcuts from '@/pages/home/components/CategoryShortcuts';
import HomeNews from '@/pages/home/components/HomeNews';
import HomeCollections from '@/pages/home/components/HomeCollections';
import HomeAbout from '@/pages/home/components/HomeAbout';

export default function Home() {
  useSeo({
    title: '玩偶姐姐影视内容平台_热门影视资讯与剧集推荐',
    description:
      '玩偶姐姐影视内容平台，为您提供最新影视资讯、电视剧和电影推荐，涵盖多类型影视作品，满足观众多元化观看需求。',
    keywords: '玩偶姐姐,影视资讯,电视剧推荐,电影推荐,影视作品,影视平台,影视人物',
  });

  const movies = contentItems
    .filter((item) => item.type === 'movie')
    .sort((a, b) => (b.heat ?? 0) - (a.heat ?? 0))
    .slice(0, 5);
  const tvshows = contentItems
    .filter((item) => item.type === 'tvshow')
    .sort((a, b) => (b.heat ?? 0) - (a.heat ?? 0))
    .slice(0, 5);
  const ranking = contentItems
    .filter((item) => item.type === 'movie' && typeof item.rating === 'number')
    .sort((a, b) => (b.rating ?? 0) - (a.rating ?? 0))
    .slice(0, 5);
  const news = contentItems
    .filter((item) => item.type === 'news')
    .sort((a, b) => (b.date ?? '').localeCompare(a.date ?? ''))
    .slice(0, 5);

  return (
    <div className="w-full">
      <h1 className="sr-only">玩偶姐姐影视内容平台 - 最新影视资讯、电视剧与电影推荐</h1>
      <HeroCarousel />
      <CategoryShortcuts />

      <section className="w-full px-4 py-10 md:px-8 md:py-14">
        <SectionHeading
          eyebrow="Now in Cinemas"
          title="热门电影推荐"
          description="院线热度与口碑双重筛选，五部这个月最值得进影院的电影。"
          moreTo="/movies"
          moreLabel="全部电影"
        />
        <div className="mt-7 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-5">
          {movies.map((movie) => (
            <ContentCard key={movie.id} item={movie} />
          ))}
        </div>
      </section>

      <section className="w-full bg-background-100 px-4 py-10 md:px-8 md:py-14">
        <SectionHeading
          eyebrow="On Air"
          title="正在热播的电视剧"
          description="从悬疑到家庭，从国产到日韩，追剧清单每周更新一次。"
          moreTo="/tvshows"
          moreLabel="全部电视剧"
        />
        <div className="mt-7 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-5">
          {tvshows.map((show) => (
            <ContentCard key={show.id} item={show} />
          ))}
        </div>
      </section>

      <HomeNews news={news} ranking={ranking} />
      <HomeCollections />
      <HomeAbout />

      <section className="w-full px-4 pb-4 md:px-8">
        <div className="flex flex-col items-start justify-between gap-4 rounded-lg bg-primary-500 px-5 py-8 md:flex-row md:items-center md:px-8">
          <div>
            <h2 className="font-heading text-lg font-bold text-background-50 md:text-xl">
              想找一部特定的片子？
            </h2>
            <p className="mt-2 text-sm text-background-100/85">
              直接搜索片名、演员或关键词，我们会把相关的电影、剧集和资讯一起找出来。
            </p>
          </div>
          <Link
            to="/search"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400"
          >
            <i className="ri-search-line text-[16px]"></i>
            开始搜索
          </Link>
        </div>
      </section>
    </div>
  );
}